import styled from 'styled-components';
import { Icon, loading } from '@web-chat-core/ui-kit';

export const ProcessorButton = styled.button<{ $isSelected?: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1 0 30%;
    gap: 8px;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    width: 100%;
    overflow: hidden;

    border-radius: 8px;
    border: ${(props) =>
        props.$isSelected ? `3px solid ${props.theme.root.colors.accent.textOrIcon}` : '3px solid transparent'};
    background-color: ${(props) => props.theme.root.colors.basicColors['6%']};
    cursor: pointer;

    &:hover {
        background-color: ${(props) => props.theme.root.colors.basicColors['10%']};
    }

    &:disabled {
        background-color: ${(props) => props.theme.root.colors.basicColors['4%']};
        cursor: auto;
    }
`;

export const ImageProcessorButton = styled(ProcessorButton)`
    position: relative;
`;

export const PreviewImage = styled.img<{ $isLoaded: boolean }>`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    opacity: ${({ $isLoaded }) => ($isLoaded ? 1 : 0)};
    pointer-events: none;
`;

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

export const LoadingIcon = styled(Icon)`
    ${loading}
`;
